import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';

const SponsorshipEmailListPopup = (props) => {
    const [checkedItems, setCheckedItems] = useState({});
    const [currentId, setCurrentId] = useState(null);
    const [fields, setFields] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        fields.forEach((field) => {
            if (!checkedItems[field.name]) {
                setFields(fields.filter((item) => item.id !== currentId));
            }
        });
    }, [checkedItems, fields]);

    const handleChecked = (event, data) => {
        setCheckedItems({
            ...checkedItems,
            [event.target.name]: event.target.checked
        });
        setFields([...fields, data]);
        setCurrentId(data.id);
    };

    const handleClick = () => {
        props.addFieldsFromGAPI(fields);
    };

    const handleChange = useCallback((e) => {
        setSearch(e.target.value);
    }, []);

    const filterSearch = props.fields.filter((field) =>
        Object.keys(field).some((key) => field[key].toLowerCase().includes(search.toLowerCase()))
    );

    return (
        <>
            <h4>{i18n.t('sponsorship:who_should_homeexchanger')}</h4>
            <div>{i18n.t('sponsorship:select_people')}</div>
            <div className="modal-search-input">
                <div className="modal-search-icon">
                    <i className="icon-search"></i>
                </div>
                <input placeholder={i18n.t('sponsorship:search_contacts')} onChange={handleChange} />
            </div>
            <div className="modal-list-contact-container">
                {filterSearch.map((field) => (
                    <label
                        htmlFor={field.id}
                        key={field.id}
                        className="modal-list-contact"
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="modal-info">
                            <div className="modal-avatar">
                                <img src={field.photo} />
                            </div>
                            <div className="modal-contact-container">
                                <div className="modal-contact-name">{field.name}</div>
                                <div className="modal-contact-email">{field.email}</div>
                            </div>
                        </div>
                        <span className="modal-checkbox">
                            <input
                                type="checkbox"
                                name={field.name}
                                id={field.id}
                                checked={checkedItems[field.name]}
                                // eslint-disable-next-line react/jsx-no-bind
                                onChange={(e) => handleChecked(e, field)}
                            />
                            <span>{checkedItems[field.name] && <i className="icon-check" />}</span>
                        </span>
                    </label>
                ))}
            </div>
            <button
                className="btn btn-primary"
                id="confirm-email-sponsorship"
                // eslint-disable-next-line react/jsx-no-bind
                onClick={handleClick}
            >
                {i18n.t('common:input-confirm.text')}
            </button>
        </>
    );
};

SponsorshipEmailListPopup.propTypes = {
    fields: PropTypes.array,
    addFieldsFromGAPI: PropTypes.func
};

export default SponsorshipEmailListPopup;
